import { Spinner } from "react-bootstrap";

function Loader() {
  return (
    <Spinner
      animation="border"
      role="status"
      style={{
        margin: "auto",
        display: "block"
      }}>
      <span className="sr-only">Loading...</span>
    </Spinner>
  );
}

export default Loader;
